var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "조직도 마스터",
            editable: _vm.editable,
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            selection: "multiple",
            rowKey: "id",
            usePaging: false,
          },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props }) {
                return [
                  _c("c-text", {
                    attrs: {
                      editable: _vm.editable,
                      readonly: true,
                      afterIcon: _vm.editable
                        ? [
                            {
                              name: "search",
                              click: true,
                              callbackName: "searchSenior",
                            },
                            {
                              name: "close",
                              click: true,
                              callbackName: "removeSenior",
                            },
                          ]
                        : null,
                      name: "seniorId",
                    },
                    on: {
                      searchSenior: function ($event) {
                        return _vm.searchSenior(props.row)
                      },
                      removeSenior: function ($event) {
                        return _vm.removeSenior(props.row)
                      },
                      dataChange: function ($event) {
                        return _vm.dataChange(props.row)
                      },
                    },
                    model: {
                      value: props.row.seniorName,
                      callback: function ($$v) {
                        _vm.$set(props.row, "seniorName", $$v)
                      },
                      expression: "props.row.seniorName",
                    },
                  }),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: {
                          label: "LBLADD",
                          showLoading: false,
                          icon: "add",
                        },
                        on: { btnClicked: _vm.add },
                      })
                    : _vm._e(),
                  _vm.editable && _vm.grid.data.length > 0
                    ? _c("c-btn", {
                        attrs: { label: "LBLREMOVE", icon: "remove" },
                        on: { btnClicked: _vm.removeRow },
                      })
                    : _vm._e(),
                  _vm.editable && _vm.grid.data.length > 0
                    ? _c("c-btn", {
                        attrs: {
                          url: _vm.saveUrl,
                          isSubmit: _vm.isSave,
                          param: _vm.grid.data,
                          mappingType: "POST",
                          label: "LBLSAVE",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveItem,
                          btnCallback: _vm.saveCallback,
                        },
                      })
                    : _vm._e(),
                  _c("c-btn", {
                    attrs: { label: "LBLSEARCH", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }